import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const authApi = {
  login: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/login",
      data,
      method: "post",
    }),
  register: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/signup",
      data,
      method: "post",
    }),

  passwordUpdate: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/password/update",
      data,
      method: "post",
    }),

  profile: (): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/profile",
    }),
  forgotPass: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/forgot",
      data,
      method: "post",
    }),
  resetPass: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/customer/auth/password/reset",
      data,
      method: "post",
    }),
};
